import React, { useState } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { AppWrap, MotionWrap } from '../../wrapper';
import { motion } from 'framer-motion';
import './Testimonial.scss';
import { images } from '../../constants/';

const testimonials = [
  {title:"John D.", description:" I was amazed by the exceptional service I received! Burhan went above and beyond to help me with my issue. Highly recommended! ", imgUrl:images.people01},
  {title:"Sarah .", description:" I've been a customer for years, and I can confidently say Burhan delivers on its promises. His products are top-match, and the support is outstanding.", imgUrl:images.people02},
  {title:"Emily M.", description:"Burhan's professionalism and attention to detail are unparalleled. He truly cares about his customers and their satisfaction.", imgUrl:images.people03},
  {title:"Mark T.", description:" I had doubts before trying his services, but he exceeded all my expectations. The results were impressive, and I'm glad I chose him.", imgUrl:images.people04}
];
const brands=[
  {imgUrl:images.skype, name:"skype"},
  {imgUrl:images.bolt, name:"bolt"},
  {imgUrl:images.nb, name:"nb"},
  {imgUrl:images.spotify, name:"spotify"},
  {imgUrl:images.amazon, name:"amazon"},
  {imgUrl:images.adidas, name:"adidas"},

]

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // const handleClick = (index) => {
  //   setCurrentIndex(index);
  // };

  const prevTestimonial = () => {
    const prevIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
    setCurrentIndex(prevIndex);
  };

  const nextTestimonial = () => {
    const nextIndex = (currentIndex + 1) % testimonials.length;
    setCurrentIndex(nextIndex);
  };

  return (
    <>
      <div className="app__testimonial-item app__flex">
        <img src={testimonials[currentIndex].imgUrl} alt={testimonials[currentIndex].name} />
        <div className="app__testimonial-content">
          <p className="p-text">{testimonials[currentIndex].description}</p>
          <div>
            <h4 className="bold-text">{testimonials[currentIndex].title}</h4>
            <h5 className="p-text">{testimonials[currentIndex].company}</h5>
          </div>
        </div>
      </div>

      <div className="app__testimonial-btns app__flex">
        <div className="app__flex" onClick={prevTestimonial}>
          <HiChevronLeft />
        </div>

        <div className="app__flex" onClick={nextTestimonial}>
          <HiChevronRight />
        </div>
      </div>

      <div className="app__testimonial-brands app__flex">
        {/* Render brands here */}
      </div>

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={brand.imgUrl} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg',
);
